<template>
  <div class="column full-height">
    <div class="row justify-center">
      <img :src="headerImg" class="col-xs-5 col-sm-3 col-md-2" />
      <p class="text-weight-medium full-width text-center q-mt-md">
        To help calculate your insurance and rego we have your postcode listed
        as:
      </p>
      <SAIFormError class="q-mt-md" v-if="postcodeError.$error" />
      <SAIInput
        :disable="disable"
        :error="postcodeError.$error"
        class="q-mt-md col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4"
        placeholder="Enter Postcode"
        :large="true"
        :value="user.postcode"
        @input="$emit('update:user', { ...user, postcode: $event })"
      />
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        :disable="disable"
        :loading="loading"
        label="Next"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import { SAIInput, SAIBtn, SAIFormError } from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfilePostcode',
  props: {
    headerImg: String,
    disable: Boolean,
    loading: Boolean,
    postcodeError: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    SAIInput,
    SAIBtn,
    SAIFormError,
    QSpace
  }
};
</script>
